export default __webpack_public_path__ + "static/hero-graphic-f3b7c2bc0b0c67e1d2e4bda616d409a2.png";